import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const CookieBanner = () => {
  return null; // Disabled
};

export default CookieBanner;